module.exports = require('./helpers/bundle-url').getBundleURL('fUmN8') + "logo-dark.eefe0b7f.svg";